import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import assetsPath from '../../index.js';

/**
 * The Header-Very-Light molecule contains a light header with only one logo.
 *
 * baseUrl - The base Url. Used to build others Url in component.
 * isShown - Display Orange logo (optional) - No set by default.
 * languages - Slot for displaying switch lang links.
 */
@customElement('nn-header-very-light')
export class HeaderVeryLight extends LitElement {
  static styles = css`
    :host {
      --nn-generic-link_link_font-size: 24px;
      --nn-icon-inline_icon-inline_color: #000;
      --nn-generic-link_link_text-decoration: none;
      background: var(--nn-header-very-light_host_background, #0e0e0e);
      border: 0;
      border-radius: 0;
      box-sizing: border-box;
      display: block;
      font-family: 'font-light';
      font-size: var(--nn-header-very-light_host_font-size, 16px);
      line-height: calc(4px + 2ex);
      margin: 0 auto;
      padding: 0;
      width: 100%;
    }
    #header-very-light,
    #header-very-light * {
      box-sizing: border-box;
    }
    #header-very-light .container {
      align-items: center;
      display: flex;
      gap: var(--nn-header-very-light_container_gap, 16px);
      justify-content: var(
        --nn-header-very-light_container_justify-content,
        space-between
      );
      margin: 0 auto;
      max-width: 1470px;
      min-height: var(--nn-header-very-light_container_min-height, 68px);
      padding: var(--nn-header-very-light_container_padding, 0 15px);
      width: 100%;
    }
    #header-very-light {
      background: var(--nn-header-very-light_background, #f8f8f8);
      border-top: var(--nn-header-very-light_border-width, 16px) solid
        var(--nn-header-very-light_forder-top-color, #0e0e0e);
      font-family: 'font-light';
      font-size: var(--nn-header-very-light_font-size, 16px);
      margin: 0;
      padding: 0;
    }
    .switch-language {
      align-items: center;
      display: inline-flex;
      gap: var(--nn-header-very-light_switch-language_gap, 8px);
      justify-content: end;
    }
    @media (max-width: 479px) {
      :host {
        --nn-header-very-light_container_padding: 15px;
        --nn-header-very-light_container_min-height: 62px;
        --nn-header-very-light_border-width: 0;
      }
      .header-very-light.is-shown .container {
        --nn-header-very-light_container_justify-content: center;
      }
      #header-very-light.is-shown .container {
        flex-direction: column;
      }
    }
  `;

  @property({ type: String }) baseUrl = 'https://www.nordnet.com';

  @property({ type: Boolean }) isShown = false;

  render() {
    if (!this.isShown) {
      return html`
        <header id="header-very-light" class="header-very-light not-is-shown">
          <div class="container">
            <a href="${this.baseUrl}" title="Nordnet">
              <img
                id="header-logo-nordnet"
                src="${assetsPath}/images/logos/logo-nordnet-black.svg"
                alt="Nordnet"
                width="155"
                height="28"
              />
            </a>
            <slot class="switch-language" name="languages"></slot>
          </div>
        </header>
      `;
    }
    return html`
      <header id="header-very-light" class="header-very-light is-shown">
        <div class="container">
          <a id="footer-logo-nordnet" title="Nordnet" href="${this.baseUrl}">
            <img
              src="${assetsPath}/images/logos/logo-nordnet-black.svg"
              alt="Nordnet"
              width="155"
              height="28"
            />
          </a>
          <img
            ${this.isShown}
            src="${assetsPath}/images/logos/logo-orange-with-baseline.png"
            alt="Orange"
            width="134"
            height="36"
          />
        </div>
      </header>
    `;
  }
}
